import { Innertube, UniversalCache } from "youtubei.js";
import { PROXY_URL } from "../../api";

export const youtubeClient = Innertube.create({
  generate_session_locally: true,
  fetch: async (input: RequestInfo | URL, init?: RequestInit) => {
    // url
    const url =
      typeof input === "string"
        ? new URL(input)
        : input instanceof URL
        ? input
        : new URL(input.url);

    // transform the url for use with our proxy.
    url.searchParams.set("__host", url.host);
    url.host = PROXY_URL;
    url.protocol = "https";

    const headers = init?.headers
      ? new Headers(init.headers)
      : input instanceof Request
      ? input.headers
      : new Headers();

    // now serialize the headers
    url.searchParams.set("__headers", JSON.stringify([...headers]));

    headers.delete("user-agent");
    const method =
      init?.method ?? (input instanceof Request ? input.method : "GET");

    const request = new Request(url.toString(), {
      method,
      headers,
      body: init?.body,
      // @ts-expect-error old typescript version
      duplex: "half"
    });

    return fetch(request);
  },
  cache: new UniversalCache(false)
});
